import type { PropertyCreatedEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const PropertyCreatedIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<path d="M2.5 7.5 8 2.5l5.5 5M4 6.5V13h8V6.5" />
	</svg>
)

export function PropertyCreatedRow({ event }: { event: PropertyCreatedEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	return (
		<JournalRowShell
			icon={<PropertyCreatedIcon />}
			headline={t.journal.events.propertyCreated.label}
			actor={actor}
			iso={event.createdAt}
			eventType="property.created"
			aria={interpolate(t.journal.events.propertyCreated.aria, { actor })}
		/>
	)
}
